import { memo } from "react";

import { externalLink } from "@/routes/_constants/external-link";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { SelectField } from "@/components/ui/form/fields/select-field";

import { usePostBookingSurveyToggle } from "./hooks/use-post-booking-survey-toggle";

/** 予約後アンケートの案内記事 */
const POST_BOOKING_SURVEY_GUIDE_URL = `${externalLink.faqSite}/media/news/3d0fffe15c57814ebf0edcf7497cfcde`;

export const QuestionPostBookingSurveySection = memo(() => {
	const {
		isEdited,
		hasError,
		isUnset,
		bookedGuestSurveyDisplayStatus,
		postBookingSurveyDisplayOptions,
		onSetBookedGuestSurveyDisplayStatus,
	} = usePostBookingSurveyToggle();

	const guide =
		`予約完了後に、宿の知り方（またはご利用回数）と、詳しく教えていただいた内容をゲストに伺う予約後アンケートです。回答は顧客管理の予約詳細で確認できます。未設定はゲストにはオン相当で表示されます。オフはゲストに表示しません。<br />詳しくは<a href="${POST_BOOKING_SURVEY_GUIDE_URL}" target="_blank" rel="noopener noreferrer" class="text-link-400 underline-offset-4 hover:underline">こちら</a>`;

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title="予約後アンケート"
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<div className="flex flex-col gap-2">
					<SelectField
						label="予約完了画面に予約後アンケートを表示する"
						value={bookedGuestSurveyDisplayStatus.value}
						errorMessage={bookedGuestSurveyDisplayStatus.error}
						options={postBookingSurveyDisplayOptions}
						handleValueChange={onSetBookedGuestSurveyDisplayStatus}
					/>
					{isUnset && (
						<p className="text-sm font-medium text-error-600">
							未設定の場合、ゲストの予約完了画面にはアンケートが表示されます。
						</p>
					)}
				</div>
			}
		/>
	);
});

QuestionPostBookingSurveySection.displayName = "QuestionPostBookingSurveySection";
